
export default {
  name: "CardEsoSectionMembers",
  props: {
    esoId: String,
    isOwner: Boolean,
    editable: Boolean,
    allowAdd: Boolean,
    members: { type: Array, default: () => [] },
    invitedMembers: { type: Array, default: () => [] },
  },
  data() {
    return {
      dialogInvitation: false,
      dialogEditStartupMember: false,
      editedMember: {},
    };
  },
  computed: {
    toast() {
      return this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    },
    swalOpt() {
      return {
        type: "info",
        text: this.$t("startup.page.question.delete"),
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonText: this.$t("dialog.cancel"),
        confirmButtonText: this.$t("dialog.yes"),
        reverseButtons: true,
      };
    },
  },
  methods: {
    refresh() {
      this.$emit("updated");
    },
    addMember() {
      this.dialogInvitation = true;
    },
    getUsername({ first_name, first_name_kh, last_name, last_name_kh } = {}) {
      if (!this.$isKm()) return [first_name, last_name].join(" ");
      return [first_name_kh || first_name, last_name_kh || last_name].join(" ");
    },
    onEditMember(item) {
      this.editedMember = Object.assign({}, item);
      this.dialogEditStartupMember = true;
    },
    onDeleteMember({ isReview, memberId }) {
      this.$swal
        .fire({
          type: "info",
          text: this.$t("startup.page.question.delete"),
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonText: this.$t("dialog.cancel"),
          confirmButtonText: this.$t("dialog.yes"),
          reverseButtons: true,
        })
        .then(({ value }) => {
          if (!value) return;

          let uri = isReview
            ? `/base-api/me/invite-team-request/${memberId}/?send_out=true`
            : `/base-api/eso/${this.esoId}/team/${memberId}`;

          this.$axios
            .delete(uri)
            .then((response) => {
              const _title = this.$t("common.deleted_successful");
              this.toast.fire("", _title, "success");
              this.refresh();
            })
            .catch((error) => {
              const _title = this.$t("common.error");
              this.$swal.fire(_title, error.toString(), "error");
            });
        });
    },
    onSaveMember(payload) {
      const member = Object.assign({}, payload);
      return this.onUpdateMember(member);
    },
    onUpdateMember(member) {
      const id = this.esoId;
      var memberId = member.id;

      var payload = { role: member.role };
      this.updateStartupMember({ id, memberId, payload })
        .then((res) => {
          this.toast.fire("", this.$t("user.profile.save_success"), "success");
          this.refresh();
        })
        .catch((error) => {
          const message = error?.data?.message || error?.message || "Error";
          console.log(message);
          this.$swal.fire(this.$t("common.error"), message, "error");
        })
        .finally(() => {
          this.dialogEditStartupMember = false;
        });
    },
  },
};
